
export interface CacheOptions {
    duration: number;
    jitter?: number; // to avoid cache entries expiring at the same time, can add some jitter
}

export class Cache<T> {
    constructor(private readonly options: CacheOptions) {}

    private readonly map = new Map<string, { value: T, expires: Date }>();
    get(id: string) {
        const entry = this.map.get(id);
        if (entry?.expires && entry.expires.getTime() > Date.now()) return entry.value;
        return undefined;
    }

    set(id: string, value: T) {
        const expires = new Date(Date.now() + this.options.duration + Math.random() * (this.options.jitter ?? 0));
        this.map.set(id, { value, expires });
        return value;
    }

    clear(id: string) {
        this.map.delete(id);
    }
}
